import type Category from '../../core/types/category';

const filterCategories = (categories: Category[], activeIds: string[]) => {
    const filterFn = (
        cats: Category[],
        ids: (string | null)[],
        excludedIds: string[] = []
    ) => {
        return cats.filter(
            ({ id }) => ids.includes(id) && !excludedIds.includes(id)
        );
    };

    const filteredCategories: Category[] = [...filterFn(categories, activeIds)];

    let breakLoop = filteredCategories.every(({ parentId }) => !parentId);

    while (!breakLoop) {
        const filteredParents = filterFn(
            categories,
            filteredCategories.map(({ parentId }) => parentId),
            filteredCategories.map(({ id }) => id)
        );

        filteredCategories.push(...filteredParents);

        breakLoop = filteredParents.every(({ parentId }) => !parentId);
    }

    return filteredCategories.sort(
        (a, b) =>
            categories.findIndex(item => item.id === a.id) -
            categories.findIndex(item => item.id === b.id)
    );
};

export default filterCategories;
